import {
  Box, FormControl, FormLabel, Heading, Text,
} from '@chakra-ui/react';
import { Controller } from 'react-hook-form';
import { Select } from 'chakra-react-select';

import React from 'react';

const Body = ({ control }) => {
  const options = [{ value: 'default', label: 'Default template' }];

  return (
    <>
      <FormControl my="4">
        <FormLabel fontSize="sm">Body</FormLabel>
        <Controller
          control={control}
          name="body_type"
          render={({ field: { onChange, ref } }) => (
            <Select
              inputRef={ref}
              defaultValue={options.find((o) => o.value === 'default')}
              onChange={(val) => onChange(val.value)}
              placeholder="Select option"
              options={options}
            />
          )}
        />
      </FormControl>
      <Box bg="gray.200" p="4" color="gray.600" rounded={4}>
        <Heading size="lg">Submize</Heading>
        <Text>
          You got a new response in the form [[form_name]]
          <br />
          You can see all the responses on our app
        </Text>
        <Heading size="sm" mt="5">Response</Heading>
        <Box bg="gray.300" width="80%" my="2" p="4" rounded={2}>
          {'<-- list of fields -->'}
        </Box>
        <Text color="gray.500" mt="5" fontSize="sm">
          The response was submitted from IP: 127.0.0.1 (Argentina)
        </Text>
      </Box>
    </>
  );
};

export default Body;
